import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="response-signals"
export default class extends Controller {
  connect() {
    const events = this.element.getAttribute("data-events").split(' ');
    for (var i = 0; i < events.length; i++) {
      document.dispatchEvent(new Event(events[i]));
    }

    const refresh = this.element.getAttribute("data-refresh").split(' ');
    for (var i = 0; i < refresh.length; i++) {
      // Find elements across the whole page that have a matching data-refresh-on criterion.
      const elements = $("[data-refresh-on='" + refresh[i] + "']");
      for(var e = 0; e < elements.length; e++) {
        const element = elements[e];

        element.classList.add("animate-pulse");

        $.ajax({
          type: 'GET',
          url: element.getAttribute('data-refresh-url'),
          success: (response) => {
            Turbo.renderStreamMessage(response);
          },
          error: (xhr, textStatus, errorThrown) => {
            // TODO
          }
        });

      }
    }

    const redirect = this.element.getAttribute("data-redirect")
    if (redirect !== undefined && redirect.length > 0 && !redirect.includes("://")) {
      history.pushState(
        { turbo_frame_history: true },
        "",
        redirect
      )
      Turbo.visit(redirect)
    } else if (redirect.includes("://")) {
      window.location = redirect
    }
  }
}
